module.exports = __webpack_public_path__ + "static/media/news-1.d4aa58ef.svg";